$(document).ready(function () {
  let hideTimeout;
  let animationTimeout;
  let currentSubmenu = null;

  $('.mega-menu-box').on('mouseenter', function () {
    clearTimeout(hideTimeout);
    clearTimeout(animationTimeout); // Cancel previous animation timer

    const $submenu = $(this).find('.header__submenu');
    const $bottomImg = $(this).find('.mega-bottom-img');

    // Show submenu
    $submenu.addClass('open').css({
      visibility: 'visible',
      opacity: 1,
    });

    // Set height variable
    const fullHeight = $submenu[0].scrollHeight;
    $('html').css('--navHeight', `${fullHeight}px`);

    // Close previous submenu
    if (currentSubmenu && currentSubmenu[0] !== $submenu[0]) {
      currentSubmenu.removeClass('open').css({
        opacity: 0,
        visibility: 'hidden',
      });

      // Reset any animation on other mega-bottom-imgs
      $('.mega-bottom-img').removeClass('animate-up');
    }

    currentSubmenu = $submenu;

    // Trigger bottom image animation after 3 seconds
    animationTimeout = setTimeout(() => {
      $bottomImg.addClass('animate-up');
    }, 100);
  });

  $('.mega-menu-box').on('mouseleave', function () {
    const $submenu = $(this).find('.header__submenu');
    const $bottomImg = $(this).find('.mega-bottom-img');

    clearTimeout(animationTimeout); // Cancel animation if leaving early

    hideTimeout = setTimeout(() => {
      $submenu.removeClass('open').css({
        opacity: 1,
        visibility: 'hidden',
      });

      $bottomImg.removeClass('animate-up'); // Reset animation
      $('html').css('--navHeight', '0px');
      currentSubmenu = null;
    }, 300);
  });

  // Hover effect for submenu-item
$('.header__inline-menu .header-submenu-item-main').hover(
  function () {
    // Add class to submenu items
    $('.header-submenu-item').addClass('height-auto-set');

    // Close search dropdown if open
    const $searchDetails = $('.header__search details');
    if ($searchDetails.prop('open')) {
      $searchDetails[0].removeAttribute('open');
      if (typeof lenis !== 'undefined') {
      lenis.start();
      lenis.scrollTo(this.savedScrollY, { immediate: true }); // ✅ now scrollY is preserved
    }
    }
  },
  function () {
    // Remove class from submenu items
    $('.header-submenu-item').removeClass('height-auto-set');
  }
);

});

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

function initScrollProgressBar() {  

  const progressBar = document.querySelector('.progress-bar');
  const progressBarWrap = document.querySelector('.progress-bar-wrap');

  // Animate the progress bar as you scroll
  gsap.to(progressBar, {
    scaleX: 1,
    ease: 'none', // no ease, we control smoothness with the 'scrub' property
    scrollTrigger: {
      trigger: document.body, // Track the entire page
      start: 'top top',
      end: 'bottom bottom',
      scrub: 0.5, // control the amount of time it takes for the bar to catch up with scroll position
    },
  });

  // Click listener to scroll to a specific position, feel free to remove if you dont want it!
  progressBarWrap.addEventListener('click', (event) => {
    const clickX = event.clientX;
    const progress = clickX / progressBarWrap.offsetWidth;
    const scrollPosition = progress * (document.body.scrollHeight - window.innerHeight);
  
    gsap.to(window, {
      scrollTo: scrollPosition,
      duration: 0.725,
      ease: 'power3.out',
    });
  });  
}

// Initialize Scroll Progress Bar
document.addEventListener('DOMContentLoaded', () => {
  initScrollProgressBar();
});


const progressBars = document.querySelectorAll('.show-progress-bar');
const progressWrap = document.querySelector('.progress-bar-wrap');

if (progressBars.length === 1) {
    progressWrap.style.display = 'block';
} else {
    progressWrap.style.display = 'none';
}
